import { AutogenModelCarrierPayeeMulticompany, AutogenRowCarrierPayeeMulticompany } from "./autogen/AutogenModelCarrierPayeeMulticompany";

export class ModelCarrierPayeeMulticompany extends AutogenModelCarrierPayeeMulticompany<RowCarrierPayeeMulticompany> {
	constructor() {
		super(RowCarrierPayeeMulticompany);
	}
}

export class RowCarrierPayeeMulticompany extends AutogenRowCarrierPayeeMulticompany {
}